import styled from "styled-components";

export const Wrapper = styled.div`
.cus-table th:nth-child(1), .cus-table .ant-table-tbody td:nth-child(1){
    background: #fff;
}
.cus-table .ant-table-tbody tr td:nth-child(1){
    background: #fff;
    z-index: 1;
}
.cus-table{
    .ant-table-tbody tr:nth-child(2){  
        border: 1px solid #f00;
        display: none;
    }

}    
`